import React from "react";
import TopContent from "components/Container/top.content";
import TableContent from "components/Container/table.content";
import { useAlluser } from "context/AlluserContext";

const MainContent = (props) => {
  const { filterData } = useAlluser();
  let userData = window.$user_profile;
  if (filterData?.data === "") {
    return "";
  }
  // console.log("main => ", filterData);
  return (
    <div id="profile-content" className="inner-container row">
      <TopContent userData={userData} />
      <TableContent userData={userData} />
    </div>
  );
};

export default MainContent;
